import { useCallback, useEffect, useRef, useState } from "react";
import { Form, Image, ProgressBar } from "react-bootstrap";
import { CommunicationService } from "@propertelligent/client-api";
import { GetImages } from "../../../../utils/GetImages";
import CustomTooltip from "../../../common/CustomTooltip";
import apiHelper from "../../../../utils/apiHelper";
import CustomInputs from "../../../common/Inputs";
import EditorToolBar from "../../../common/EditorToolBar";
import AddButtonWithArrow from "../../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { useGeneratePdfContext } from "../../../../utils/context/GeneratePdfContext";
import { NotificationType, PubSub, TopicsEnum, } from "../../../../utils/pubsub";
import { validateEmail } from "../../../../utils/validateHelper";
import { useError } from '../../../../utils/context/ErrorContext'
import { debounce } from "lodash";
import { sendPersonalEmail, sendPersonalOutlookEmail, replyOutlookMessage, forwardOutlookMessage, searchOutlookContacts, getOutlookMessage, EmailProviderType } from "../personalEmailApi";
interface FormDataObject {
  Attachments?: Blob[];
}
const Compose = ({
  emailId,
  replyId,
  setReplyId,
  getEmailMessages,
  replytype,
  forwardBody = undefined,
  compose,
  setcompose,
  // EmailProviderType.Gmail (default), .CustomPopSmtp, or .Office365. SMTP only ever hits the new-message
  // branch below — POP3 has no reply/forward entry point (see .claude/context/emails.md Rule 12's Phase 2
  // scope note), so replyId/emailId are never populated when providerType is CustomPopSmtp. Office365 now
  // supports reply/forward too (Phase 2, ShowOutlookMessage.tsx) alongside its existing plain-send path.
  providerType = EmailProviderType.Gmail,
  // Called alongside getEmailMessages on every successful send/reply/forward so the Inbox/Sent/Important
  // tab counts refresh immediately rather than waiting on the next navigation/login (bug/ui-bugfix-batch9
  // item 9). Optional -- callers that don't surface tab counts (none currently) simply omit it.
  onEmailCountChanged = undefined,

}) => {
  const { errors, errorMessages, setErrors, setErrorMessages, clearErrors } = useError();
  const [to, setTo] = useState("");
  const [recipients, setRecipients] = useState([]);
  const [subject, setSubject] = useState("");
  const bodyRef = useRef(null);
  const [suggetions, setSuggetions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const searchInputRef = useRef(null);
  const { filesWithProgress, setFilesWithProgress } = useGeneratePdfContext();
  // Guards against a second submit firing while one is already in flight (repeated clicks/Enter before
  // the first apiHelper call resolves) -- the actual cause of "multiple emails getting sent" on repeated
  // clicks (bug/ui-bugfix-batch9), not a missing debounce. Also drives the Send button's existing,
  // previously-unused `loading` affordance. The ref is the authoritative re-entrancy guard (read/set
  // synchronously in handleSubmit, independent of React's render timing); the state mirror is only for
  // re-rendering the Send button's disabled/loading props.
  const isSendingRef = useRef(false);
  const [isSending, setIsSending] = useState(false);
  const setSending = (value: boolean) => {
    isSendingRef.current = value;
    setIsSending(value);
  };

  const notify = useCallback((message: string) => {
    PubSub.publish(TopicsEnum.Notification.toString(), {
      type: NotificationType.Failure,
      message,
    });
  }, []);

  useEffect(() => {
    if (replytype === "forward" && forwardBody && bodyRef.current) {
      bodyRef.current.innerHTML = `<br><br>---------- Forwarded message ----------<br>${forwardBody}`;
    }
  }, [replytype, forwardBody]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if ( searchInputRef.current && !searchInputRef.current.contains(event.target) ) {
        setSuggetions([]);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => { document.removeEventListener("click", handleClickOutside); };
  }, []);


  const handleSearch = useCallback(
    debounce((query) => {
      if (providerType === EmailProviderType.Office365) {
        searchOutlookContacts(query)
          .then((results) => setSuggetions(results ?? []))
          .catch((error) => console.error("Outlook contact search error:", error));
        return;
      }
      apiHelper(
        CommunicationService.getApiGmailSearchContacts,
        { showNotification: false },
        query
      ).then((res) => {
          const allresults: any = res.data.success;
          setSuggetions(allresults?.results);
        }).catch((error) => { });
    }, 300),
    [providerType]
  );

  useEffect(() => {
    // contact suggestions: Gmail People API and Outlook Graph People API both support search; custom SMTP
    // has no equivalent (POP3/SMTP protocols carry no contacts concept).
    if (!to || providerType === EmailProviderType.CustomPopSmtp) return;
    handleSearch(to);
  }, [to, providerType]);

  useEffect(() => {
    return () => {
      handleSearch.cancel();
    };
  }, []);

  useEffect(() => {
    if (!replyId) return;
    if (providerType === EmailProviderType.Office365) {
      // Graph auto-targets the original sender on reply (see replyOutlookMessage) -- the `to` field here only
      // needs to be pre-filled for display/forward purposes, mirroring the Gmail branch below.
      getOutlookMessage(replyId)
        .then((message) => setTo(replytype === "reply" ? message?.fromEmail ?? "" : ""))
        .catch((error) => console.error("Failed to load Outlook message for reply/forward:", error));
      return;
    }
    apiHelper(CommunicationService.getApiGmailEmailMessage, { showNotification: false },
      replyId
    ).then((res) => {
      setTo(replytype === "reply" ? res?.data?.success?.fromEmail : "");

    })
      .catch((error) => { });
  }, [replyId, replytype, providerType]);

  const handleFileChange = async (e) => {
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      setFilesWithProgress((prevFiles) => [
        ...prevFiles,
        { file, progress: 0 },
      ]);
    }
    const interval = setInterval(() => {
      setFilesWithProgress((prevFiles) =>
        prevFiles.map((file) => ({
          ...file,
          progress: Math.min(file.progress + 10, 100),
        }))
      );
    }, 500);

    setTimeout(() => {
      clearInterval(interval);
      setFilesWithProgress((prevFiles) =>
        prevFiles.map((file) => ({
          ...file,
          progress: 100,
        }))
      );
    }, 5000);
  };
useEffect(() => {
 if(replyId==null || compose==false){
  setFilesWithProgress([])
 }
}, [replyId ,compose])

  const handleDelete = (index) => {
    setFilesWithProgress((prevFiles) =>
      prevFiles.filter((file, i) => i !== index)
    );
  };

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSendingRef.current) return; // already in flight -- ignore a second submit (bug/ui-bugfix-batch9 item 11)

    const resetForm = () => {
      setTo("");
      setSubject("");
      setRecipients([]);
      if (bodyRef.current) bodyRef.current.textContent = null;
      setFilesWithProgress([]);

    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let allRecipients = [...recipients];

    if (to.trim()) {
      const email = to.trim();
      const alreadyExists = allRecipients.some((r) => r.email === email);

      if (emailRegex.test(email) && !alreadyExists) {
        allRecipients.push({ name: email, email });
      } else {
        notify("Please enter a valid email address or select from suggestions");
        return;
      }
    }

    if (!subject || subject.trim() === "") {
      notify("Subject is required");
      return;
    }

    // Validation passed -- this submit is actually going out. Disable Send until it settles.
    setSending(true);

    const formData = new FormData();
    filesWithProgress.forEach(({ file }, index) => {
      const blob = new Blob([file], { type: file.type });
      formData.append(`Attachments[${index}]`, blob, file.name);
    });

    const attachments = Array.from(formData.values()).filter(
      (val) => val instanceof Blob
    );

    const toEmails = allRecipients.map((r) => r.email).join(",");

    const messageBody = bodyRef.current.innerHTML;

    // Send email wrapper
    const sendEmail = (apiFn, emailIdParam, replyIdParam) => {
      apiHelper(
        apiFn,
        {
          successMessage: "Email sent Successfully",
          failureMessage: "Unable to send email",
          showNotification: true,
        },
        toEmails,
        subject,
        messageBody,
        emailIdParam,
        replyIdParam,
        { Attachments: attachments }
      )
        .then((res) => {
          // setReplyId(null);
          if (res?.data?.success) {
            resetForm();
            getEmailMessages?.();
            onEmailCountChanged?.();
          }
        })
        .catch((error) => {
          console.error("Email send error:", error);
        })
        .finally(() => setSending(false));
    };

    if (providerType === EmailProviderType.Office365) {
      // Personal Outlook — attachments aren't supported in reply/forward/plain-send (see Rule 12 Phase 2
      // scope note). The attachment control is hidden for this provider (see the EditorToolBar
      // disableAttachments prop below), but guard here too in case files were staged before the
      // provider was known.
      if (filesWithProgress.length > 0) {
        setSending(false);
        notify("Attachments aren't supported for an Outlook account yet. Remove them and try again.");
        return;
      }
      const onOutlookSuccess = () => {
        resetForm();
        getEmailMessages?.();
        onEmailCountChanged?.();
        setReplyId?.(null);
        PubSub.publish(TopicsEnum.Notification.toString(), {
          type: NotificationType.Success,
          message: "Email sent successfully",
        });
      };
      const onOutlookFailure = (error) => {
        console.error("Personal Outlook send error:", error);
        notify("Unable to send email");
      };

      const settleSending = () => setSending(false);
      if (!emailId) {
        sendPersonalOutlookEmail(toEmails, subject, messageBody).then(onOutlookSuccess).catch(onOutlookFailure).finally(settleSending);
      } else if (replytype === "reply") {
        replyOutlookMessage(emailId, messageBody).then(onOutlookSuccess).catch(onOutlookFailure).finally(settleSending);
      } else {
        forwardOutlookMessage(emailId, toEmails, messageBody).then(onOutlookSuccess).catch(onOutlookFailure).finally(settleSending);
      }
    } else if (!emailId && providerType === EmailProviderType.CustomPopSmtp) {
      // Personal SMTP send — new message only, no attachments in this pass (see Rule 12 Phase 2 scope note).
      // The attachment control is hidden for this provider (see the EditorToolBar disableAttachments prop below),
      // but guard here too in case files were staged before the provider was known.
      if (filesWithProgress.length > 0) {
        setSending(false);
        notify("Attachments aren't supported for a custom SMTP/POP3 account yet. Remove them and try again.");
        return;
      }
      sendPersonalEmail(toEmails, subject, messageBody)
        .then(() => {
          resetForm();
          getEmailMessages?.();
          onEmailCountChanged?.();
          PubSub.publish(TopicsEnum.Notification.toString(), {
            type: NotificationType.Success,
            message: "Email sent successfully",
          });
        })
        .catch((error) => {
          console.error("Personal SMTP send error:", error);
          notify("Unable to send email");
        })
        .finally(() => setSending(false));
    } else if (!emailId) {
      sendEmail(CommunicationService.postApiGmailSendEmailMessage, emailId, undefined);
    } else if (replytype === "reply") {

      sendEmail(CommunicationService.postApiGmailReplyEmailThread, emailId, replyId);
    } else {
      sendEmail(CommunicationService.postApiGmailForwardEmailThread, undefined, emailId);
    }
  };

  const handleUserSelect = (user) => {
    if (!recipients.some((r) => r.email === user.email)) {
      setRecipients((prev) => [...prev, user]);
    }
    setTo(""); // clear the input box
    setSuggetions([]);
  };

  const handleInputChange = (e) => {
    setTo(e.target.value);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} className="composeForm">
        <div className="composeHeader">
          <div className="emailContent ">
            <div className="ToSection">
              <p className="sub_heading fw-normal">To</p>
              <div className="multi-email-input"
                ref={searchInputRef}
                onClick={() => searchInputRef.current?.querySelector('input')?.focus()}
              >
                {recipients.map((user, index) => (
                  <div key={index} className="email-chip">
                    <span>{user.name} ({user.email})</span>
                    <img
                      src={GetImages.Blackcross}
                      onClick={() =>
                        setRecipients((prev) =>
                          prev.filter((_, i) => i !== index)
                        )
                      }
                      className="chip-close"
                      alt="remove"
                    />
                  </div>
                ))}
                <input
                  type="text"
                  value={to}
                  onChange={handleInputChange}
                  // placeholder="Type name or email"
                  className="email-input-field"
                />
              </div>
              {to.trim() !== "" && suggetions?.length > 0 && (
                <ul className="selectedChat z-index-1 top-100 position-absolute">
                  {suggetions?.map((user, index) => (
                    <li
                      key={index}
                      className="lists showMe justify-content-between"
                      onClick={() => handleUserSelect(user)}
                    >
                      <p>{user.name}</p>
                      <p>{user.email}</p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="ToSection">
            <p className="sub_heading fw-normal">Subject</p>
            <CustomInputs
              myClassName="w-100 sub_heading fw-normal black customSubjectInput"
              type="text"
              value={subject}
              onChange={handleSubjectChange}
              required
              id="customInputBorder"
              maxLength={150}
            />
          </div>
        </div>
        <div className="bodyContainer ">
          <div contentEditable={true} className="emailBody" ref={bodyRef} />
          {filesWithProgress.length > 0 && (
            <div className="file-upload-List-height">
              {filesWithProgress.map(({ file, progress }, index) => (
                <div
                  key={index}
                  className="file-upload-item">
                  <div className="d-flex flex-start w-100 gap-2 align-items-center">
                    {file.type.startsWith("image/") ? (
                      <Image
                        style={{ height: "20px", width: "20px" }}
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        thumbnail
                      />
                    ) : file.type === "application/pdf" ? (
                      <div style={{ height: "20px", width: "20px" }}>
                        <img
                          style={{ height: "100%", width: "100%" }}
                          src={GetImages.pdfImage}
                          alt="PDF File"
                        />
                      </div>
                    ) : file.type ===
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                      <div style={{ height: "20px", width: "20px" }}>
                        <a
                          href={URL.createObjectURL(file)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            style={{ height: "100%", width: "100%" }}
                            src={GetImages.DocIcon}
                            alt="Word Document"
                          />
                        </a>
                      </div>
                    ) : (
                      // Handle other file types or display a generic placeholder
                      <div style={{ height: "20px", width: "20px", background: "#ccc" }}>
                        <img
                          style={{ height: "100%", width: "100%" }}
                          src={GetImages.GrayFile}
                          alt="placeholder"
                        />
                      </div>
                    )}
                    <p className="sub_heading black fw-normal">{file.name}</p>
                  </div>
                  <div className="email-progress-container flex-end">
                    {progress > 0 && progress < 100 ? (
                      <div className="w-100">
                        <ProgressBar
                          now={progress}
                          label={`${progress}%`}
                          visuallyHidden
                        />
                      </div>
                    ) : (
                      <div className="w-100"></div>
                    )}
                    <CustomTooltip content="Remove Attachment" children={
                      <img
                        onClick={() => handleDelete(index)}
                        className="iconstyle10 clickable color-white-icon"
                        src={GetImages.Blackcross}
                        alt="Remove Attachment"
                      />
                    } />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="emailBottomSection">
          <div className="textVariation">
            <EditorToolBar
              editorRef={bodyRef}
              handleFileChange={handleFileChange}
              disableAttachments={providerType === EmailProviderType.CustomPopSmtp || providerType === EmailProviderType.Office365}
              notify={notify}
            />
          </div>
          <div className="d-flex align-items-center gap-2">
             <CustomTooltip children={ <img
                    onClick={() =>{ if(replyId){
                     setReplyId(null);
                     setFilesWithProgress([])
                    }else if(compose){
                      setFilesWithProgress([])
                      setcompose(false)
                    }
                      setFilesWithProgress([])}}
                    src={GetImages.BlackDelete}
                    alt={GetImages.BlackDelete}
                    className="iconstyle flex-end color-white-icon clickable"
                  />}
             content={"Discard"} />
            {/* {replyId  || compose ? ( */}
              {/* <CustomTooltip
                // id="tooltip-disabled"
                // placement="Discard"
                tooltip="custom-tooltip"
                Element={
                  <img
                    onClick={() =>{ if(replyId){
                     setReplyId(null);
                     setFilesWithProgress([])
                    }else if(compose){
                      setFilesWithProgress([])
                      setcompose(false)
                    }
                      
                      setFilesWithProgress([])
                      


                    }}
                    src={GetImages.BlackDelete}
                    alt={GetImages.BlackDelete}
                    className="iconstyle flex-end"
                  />
                }
              /> */}
            {/* // ) : (
            //   ""
            // )} */}
            <AddButtonWithArrow
              buttonname="Send"
              onClick={null}
              disabled={isSending}
              loading={isSending}
            />
          </div>
        </div>
      </Form>
    </>
  );
};

export default Compose;

